import $ from 'jquery';
import challengesSlider from './challengesSlider';
import textTruncator from './text-truncator';

export default () => {
  if ($('body[data-backend]').length > 0 && $('.js-what-we-ve-done-filter').length > 0) {
    filterChallengesAjax();
  } else {
    $('.js-what-we-ve-done-filter #cohort').on('change', filterChallenges);
    $('.js-what-we-ve-done-filter #cohort-entities').on('change', filterChallenges);
  }

  function filterChallengesAjax() {
    var loadMoreText = '';
    if (!isRtl) {
      loadMoreText = 'Load More';
    } else {
      loadMoreText = 'عرض المزيد';
    }
    let loadMoreTemplateHtml = $('#js-slider-load-more-template').html();
    loadMoreTemplateHtml = loadMoreTemplateHtml.replace(/\[\[loadMore\]\]/g, loadMoreText);
    $('.js-filter').last().after(loadMoreTemplateHtml);

    if (!isRtl) {
      $('.js-load-more-gallery').text('LOADING ...');
    } else {
      $('.js-load-more-gallery').text('جاري التحميل ...');
    }

    let alreadyFiltered = false;
    let time = 0;
    $('.js-what-we-ve-done-filter #cohort-search').on('change paste keyup', function () {
      let value = $(this).val();
      if (time !== null) {
        clearTimeout(time);
      }
      time = setTimeout(function () {
        if (value.length > 3 || alreadyFiltered === true) {
          alreadyFiltered = false;
          challengesFilter();
        }
      }, 500);
    });

    $('.js-what-we-ve-done-filter #cohort').on('change', challengesFilter);
    $('.js-what-we-ve-done-filter #cohort-entities').on('change', challengesFilter);
    $(document).on('click', '.load-more', function () {
      challengesFilter(false);
    });

    let isRtl = $('html').attr('dir') === 'rtl';
    let apiUrl = '/api/cohortsService/GetItems';
    let loadMoreTemplate = $('#js-slider-load-more-template');
    let itemsPerPage = $('#challenges-slider-items-per-page');
    let sortExpression = $('#challenges-slider-sort-expression').val();
    let pageNumber = $('#challenges-slider-page-number');
    let useTwoRows = $('#challenges-slider-use-two-rows');
    let selectedCohortIds = $('#challenges-slider-cohort-ids').val();
    if (useTwoRows === 'false') {
      useTwoRows = false;
    } else {
      useTwoRows = true;
    }

    let culture = 'en';
    if (isRtl) {
      culture = 'ar';
    }
    challengesFilter(false);

    function challengesFilter(clearCurrent) {
      if (clearCurrent !== false) {
        clearCurrent = true;
      }

      if (clearCurrent) {
        if ($('.load-more').length > 0) {
          $('.load-more').remove();
        }
        if ($('.js-slider').length > 0) {
          $('.js-slider').remove();
        }
        pageNumber.val(0);
      } else {
        if (!isRtl) {
          $('.js-load-more-gallery').text('LOADING ...');
        } else {
          $('.js-load-more-gallery').text('جاري التحميل ...');
        }
      }

      let take = parseInt(itemsPerPage.val());
      let skip = take * parseInt(pageNumber.val());

      let searchText = $('.js-what-we-ve-done-filter #cohort-search').val();
      let cohortId = $('.js-what-we-ve-done-filter #cohort').val();
      let leadEntityId = $('.js-what-we-ve-done-filter #cohort-entities').val();

      if (searchText.length > 3) {
        alreadyFiltered = true;
      }

      $('[data-entities]').hide();
      $('[data-cohorts]').hide();
      $('[data-cohort-id]').hide();
      $('[data-entity-id]').addClass('hidden');


      if (leadEntityId != '' || cohortId != '') {
        if (cohortId == '') {
          $('[data-entities*=\'' + leadEntityId + '\']').show();
          $('[data-entity-id=\'' + leadEntityId + '\']').removeClass('hidden');
          $('option[data-cohorts]').show();
        }
        if (leadEntityId == '') {
          $('[data-cohorts*=\'' + cohortId + '\']').show();
          $('[data-cohort-id="' + cohortId + '"]').show();
          $('[data-cohort-id="' + cohortId + '"]').find(".js-slick").slick("setPosition");
          $('option[data-entities]').show();
          $('[data-entity-id]').removeClass('hidden');
        }
        if (leadEntityId != '' && cohortId != '') {
          $('[data-cohort-id="' + cohortId + '"]').show();
          $('option[data-entities*=\'' + leadEntityId + '\']').show();
          $('option[data-cohorts*=\'' + cohortId + '\']').show();
          $('[data-entity-id=\'' + leadEntityId + '\']').removeClass('hidden');
        }
      } else {
        $('[data-entities]').show();
        $('[data-cohorts]').show();
        $('[data-cohort-id]').show();
        $('[data-entity-id]').removeClass('hidden');
        $('.js-slider .slick-slider .slick-slide').removeClass('hidden');
      }

      

      $.get(apiUrl, {
        culture,
        cohortId,
        leadEntityId,
        selectedCohortIds,
        sortExpression,
        skip,
        take,
        searchText
      }).done((data) => {
        if ($('.load-more').length > 0) {
          $('.load-more').remove();
        }
        if (data.Items.length == 0) {
          $('.js-not-found').show();
          return;
        } else {
          $('.js-not-found').hide();
        }

        let htmlToAdd = '';
        data.Items.forEach((cohort) => {

          let cohortHtml = $('#js-slider-template').html();
          let challengesHtml = '';
          cohort.RelatedChallenges.forEach((challenge) => {
            var challengeHtml = $('#js-slider-challenges-template').html();
            if (!challenge.Heading) {
              challenge.Heading = "";
            }
            if (!challenge.IconUrl) {
              challenge.IconUrl = "";
            }
            if (!challenge.ItemFullUrl) {
              challenge.ItemFullUrl = "";
            }
            if (!challenge.Title) {
              challenge.Title = "";
            }

            challengesHtml += challengeHtml.replace(/\[\[heading\]\]/g, challenge.Heading)
              .replace(/\[\[iconUrl\]\]/g, challenge.IconUrl)
              .replace(/\[\[title\]\]/g, challenge.Title)
              .replace(/\[\[results\]\]/g, challenge.Results)
              .replace(/\[\[detailsUrl\]\]/g, challenge.ItemFullUrl);
          });

          if (!cohort.Description) {
            cohort.Description = "";
          }
          if (!cohort.Title) {
            cohort.Title = "";
          }

          cohortHtml = cohortHtml.replace(/\[\[description\]\]/g, cohort.Description)
            .replace(/\[\[title\]\]/g, cohort.Title)
            .replace(/\[\[key\]\]/g, cohort.Title)
            .replace(/\[\[twoRows\]\]/g, useTwoRows)
            .replace(/\[\[challenges\]\]/g, challengesHtml);

          htmlToAdd += cohortHtml;
        });

        $("[data-challenges-slider]").removeAttr('data-challenges-slider');
        if ($('.js-slider').length == 0) {
          $('.js-filter').after(htmlToAdd);
        } else {
          $('.js-slider').last().after(htmlToAdd);
        }
        challengesSlider();
        textTruncator();

        let slidersCount = $('.js-slider').length;

        var loadMoreText = '';
        if (!isRtl) {
          loadMoreText = 'Load More';
        } else {
          loadMoreText = 'عرض المزيد';
        }
        if (slidersCount < data.TotalCount) {
          if ($('.load-more').length > 0) {
            $('.load-more').remove();
          }
          let loadMoreTemplateHtml = $('#js-slider-load-more-template').html();
          loadMoreTemplateHtml = loadMoreTemplateHtml.replace(/\[\[loadMore\]\]/g, loadMoreText);
          $('.js-slider').last().after(loadMoreTemplateHtml);
        } else {
          if ($('.load-more').length > 0) {
            $('.load-more').remove();
          }
        }

        let currentPageNumber = parseInt(pageNumber.val());
        currentPageNumber++;
        pageNumber.val(currentPageNumber);
      });
    }
  }

  function filterChallenges() {
    var entity = $('.js-what-we-ve-done-filter #cohort-entities').val();
    var cohort = $('.js-what-we-ve-done-filter #cohort').val();

    $('.js-slider .slick-slider').slick('slickUnfilter');

    $('[data-entities]').hide();
    $('[data-cohorts]').hide();
    $('[data-cohort-id]').hide();
    $('[data-entity-id]').addClass('hidden');


    if (entity != '' || cohort != '') {
      if (cohort == '') {
        $('[data-entities*=\'' + entity + '\']').show();
        $('[data-entity-id=\'' + entity + '\']').removeClass('hidden');
        $('option[data-cohorts]').show();
        $('.js-slider .slick-slider').slick('slickUnfilter').slick('slickFilter', function (index, slide) {
          return $('[data-entity-id]:not(.hidden)', slide).length > 0 || !$(slide).hasClass('hidden');
        });
      }
      if (entity == '') {
        $('[data-cohorts*=\'' + cohort + '\']').show();
        $('[data-cohort-id="' + cohort + '"]').show();
        $('[data-cohort-id="' + cohort + '"]').find(".js-slick").slick("setPosition");
        $('option[data-entities]').show();
        $('[data-entity-id]').removeClass('hidden');
      }
      if (entity != '' && cohort != '') {
        $('[data-cohort-id="' + cohort + '"]').show();
        $('option[data-entities*=\'' + entity + '\']').show();
        $('option[data-cohorts*=\'' + cohort + '\']').show();
        $('[data-entity-id=\'' + entity + '\']').removeClass('hidden');
        $('.js-slider .slick-slider').slick('slickUnfilter').slick('slickFilter', function (index, slide) {
          return $('[data-entity-id]:not(.hidden)', slide).length > 0 || !$(slide).hasClass('hidden');
        });
      }
    } else {
      $('[data-entities]').show();
      $('[data-cohorts]').show();
      $('[data-cohort-id]').show();
      $('[data-entity-id]').removeClass('hidden');
      $('.js-slider .slick-slider .slick-slide').removeClass('hidden');
    }
  }

};
